export const environment = {
  production: true,
  restws_base: "https://chepe.mx/rest",
  model:"rest",
  avmode:2 //Modo de envío de passenger types al solicitar disponibilidad. 1=[objetos] 2=[ids de passenger types]
};
